import React from 'react';
import classnames from 'classnames';

import PropTypes from 'prop-types'; 
/**
 * This is a dropdown.
 */
const Dropdown = (props) => {

    const classNames = classnames('dropdown', props.className);

    const { data, value, onChange, textField, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, ...rest } = props;

    const handleChange = (event) => {
        if (onChange) {
            onChange(event.target.value);
        }
    };
    
    return (
        <div className={classNames}>
            <select
                className="rw-dropdownlist"
                value={value}
                onChange={handleChange}
                aria-label={ariaLabel}
                aria-labelledby={ariaLabelledBy}
                {...rest}
            >
                {data && data.map((item, index) => (
                    <option key={index} value={item}>
                        {textField ? textField(item) : item}
                    </option>
                ))}
            </select>
        </div>
    );
};

Dropdown.propTypes = {
    data: PropTypes.array,
    value: PropTypes.any,
    onChange: PropTypes.func,
    textField: PropTypes.func,
    className: PropTypes.string,
    /** A descriptive ARIA label for accessibility. */
    'aria-label': PropTypes.string,
    /** The id of an element which labels the dropdown. */
    'aria-labelledby': PropTypes.string,
};

export default Dropdown;